import React from 'react';
import {
  ConnectedServicesSection,
  SectionHeading,
  ConnectedServices,
  ConnectedServiceIcon,
  ConnectedServiceLink,
} from './Connected.styles';
import {
  FaChalkboardTeacher,
  FaBookOpen,
  FaClipboardCheck,
} from 'react-icons/fa';

const Connected = () => {
  return (
    <ConnectedServicesSection>
      <SectionHeading>
        <p className="eyebrowHeader">Support Beyond the Audit</p>

        <h2>Turn Findings Into Practical Safety Improvements</h2>

        <p>
          If an audit identifies areas that need additional support, Yoda Safety
          Services can also help with training, workplace documentation, and
          digital safety tools.
        </p>
      </SectionHeading>

      <ConnectedServices>
        <ConnectedServiceLink href="/training">
          <ConnectedServiceIcon>
            <FaChalkboardTeacher />
          </ConnectedServiceIcon>

          <div>
            <span>Safety Training</span>

            <h3>Build Employee Knowledge</h3>

            <p>
              Explore online and classroom safety training for employees who
              need additional or updated workplace training.
            </p>

            <strong>
              Explore Training
              <span aria-hidden="true">→</span>
            </strong>
          </div>
        </ConnectedServiceLink>

        <ConnectedServiceLink href="/safety-manuals">
          <ConnectedServiceIcon>
            <FaBookOpen />
          </ConnectedServiceIcon>

          <div>
            <span>Safety Manuals</span>

            <h3>Strengthen Workplace Documentation</h3>

            <p>
              Develop workplace safety manuals designed around your organization
              and make them available online through a company account.
            </p>

            <strong>
              Explore Safety Manuals
              <span aria-hidden="true">→</span>
            </strong>
          </div>
        </ConnectedServiceLink>

        <ConnectedServiceLink href="/digital-safety-forms">
          <ConnectedServiceIcon>
            <FaClipboardCheck />
          </ConnectedServiceIcon>

          <div>
            <span>Digital Safety Forms</span>

            <h3>Move Safety Records Online</h3>

            <p>
              Turn existing PDF forms into digital tools employees can complete
              online while keeping submitted information easier to retrieve.
            </p>

            <strong>
              Explore Digital Forms
              <span aria-hidden="true">→</span>
            </strong>
          </div>
        </ConnectedServiceLink>
      </ConnectedServices>
    </ConnectedServicesSection>
  );
};

export default Connected;
